import { render, staticRenderFns } from "./BulkMessagesFilter.vue?vue&type=template&id=12521fd7"
import script from "./BulkMessagesFilter.vue?vue&type=script&lang=js"
export * from "./BulkMessagesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports